import React, { useState } from "react";
import API_BASE from "../config/api";
import { resolveImageUrl } from "../utils/siteHelpers";

/*
  Direct document-upload field, used for the Portfolio / Catalog / Brochure
  file (CR B5). Accepts PDF/Word/PowerPoint/image files, uploads immediately
  to /api/upload_business_file.php, and hands the returned relative path
  back through onChange.

  props:
    value        - current stored path/URL (string)
    onChange     - (newValue: string) => void
    personaluid  - used only to namespace the uploaded file's folder
*/
export default function FileUploadField({ value, onChange, personaluid }) {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");

    const fileUrl = resolveImageUrl(API_BASE, value);
    const fileName = value ? String(value).split("/").pop() : "";

    const handleFile = async (e) => {
        const file = e.target.files && e.target.files[0];
        e.target.value = "";
        if (!file) return;

        setError("");
        setUploading(true);

        const fd = new FormData();
        fd.append("file", file);
        fd.append("purpose", "brochure");
        if (personaluid) fd.append("personaluid", personaluid);

        try {
            const res = await fetch(`${API_BASE}/api/upload_business_file.php`, {
                method: "POST",
                body: fd,
            });
            const data = await res.json();
            setUploading(false);
            if (data.success) {
                onChange(data.url);
            } else {
                setError(data.message || "Upload failed.");
            }
        } catch {
            setUploading(false);
            setError("Network error while uploading.");
        }
    };

    return (
        <div>
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <label className="btn btn-sm btn-outline-primary mb-0">
                    <i className="bi bi-file-earmark-arrow-up me-1" />
                    {uploading ? "Uploading..." : value ? "Replace file" : "Upload Portfolio / Catalog / Brochure"}
                    <input type="file" accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.jpeg,.png,.webp" hidden disabled={uploading} onChange={handleFile} />
                </label>
                {value && (
                    <>
                        <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="small">
                            <i className="bi bi-eye me-1" />{fileName}
                        </a>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => onChange("")} disabled={uploading}>
                            Remove
                        </button>
                    </>
                )}
            </div>
            <div className="form-text">PDF, Word, PowerPoint or image — shown to visitors as a "Download" button.</div>
            {error && <div className="text-danger small mt-1"><i className="bi bi-exclamation-circle me-1" />{error}</div>}
        </div>
    );
}
